import { makeStyles } from '@ellucian/react-design-system/core';
import { spacing40, spacing60 } from '@ellucian/react-design-system/core/styles/tokens';
import { Typography, Illustration } from '@ellucian/react-design-system/core';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles({
    name: 'EmptyState'
})(() => ({
    noDocuments: {
        display: 'grid',
        gridGap: spacing40,
        justifyItems: 'center',
        marginBottom: spacing60,
    },
    noDocumentsText: {
        textAlign: 'center',
    },
}));

const EmptyState = () => {
    const { classes } = useStyles();

    return (
        <div className={classes.noDocuments} role="status" aria-live="polite">
            <Illustration name="no-tasks" aria-hidden="true" />
            <Typography variant="h3">
                <FormattedMessage id="supportingDocuments" />
            </Typography>
            <div className={classes.noDocumentsText}>
                <Typography>
                    <FormattedMessage id="supportingDocumentsNoDocuments" />
                </Typography>
            </div>
        </div>
    );
};

export default EmptyState;
